module.exports = __webpack_public_path__ + "img/shopping-cart.c8030fed.svg";